/* Anherb cart drawer - fix for the drawer appearing to vanish on mobile.

   EVIDENCE (on-device log, 9 Aug):
     +19175ms  #mini-cart re-rendered (12037 chars)   items present
     +23666ms  #mini-cart re-rendered  (7386 chars)   EMPTY cart render
     +25255ms  #mini-cart re-rendered (12922 chars)   items back
     +26656ms  #mini-cart re-rendered  (7386 chars)   empty again
   with NO 'DETAILS open=false', no BEFOREUNLOAD and no PAGEHIDE.

   DIAGNOSIS: the drawer was never closing and the page was never reloading.
   Each +/- tap fired its own /cart/change.js request. Taps 500-700ms apart on
   mobile beat the round-trip, so several requests were in flight at once and
   their responses landed OUT OF ORDER. Every response rewrites the entire
   drawer, so a stale one repaints an older cart - including the empty-cart
   state, whose CSS hides the items and footer. That is the 'vanish'.
   It barely shows on desktop because the round-trip is much faster there.

   FIX: coalesce rapid taps. Update the number on screen immediately, then send
   ONE request for the final value after the user stops tapping. Also ignore any
   response that is not the newest, so a late reply can never repaint the drawer.

   Set DEBUG to true to re-enable the on-screen log. */

(function () {
  var SETTLE_MS = 450;
  var DEBUG = false;
  var timers = {}, seq = 0, newest = 0, log = [], pill, panel, bodyEl;

  function say(m) {
    if (!DEBUG) return;
    log.push(new Date().toTimeString().slice(0, 8) + '  ' + m);
    if (pill) pill.textContent = 'LOG ' + log.length;
    if (bodyEl) { bodyEl.textContent = log.slice(-60).join('\n'); bodyEl.scrollTop = bodyEl.scrollHeight; }
  }

  function cartItemsFor(el) { return el.closest('cart-items'); }

  /* Coalesce taps: move the visible number now, send one request when settled. */
  function schedule(input, cartItems) {
    var line = input.dataset.index;
    if (!line) return;

    clearTimeout(timers[line]);
    timers[line] = setTimeout(function () {
      delete timers[line];
      var mine = ++seq;
      newest = mine;
      say('SEND line ' + line + ' qty ' + input.value + ' (seq ' + mine + ')');
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        cartItems.updateQuantity(line, input.value, input.getAttribute('name'));
      }
    }, SETTLE_MS);
  }

  function onQtyPress(event) {
    var btn = event.target.closest && event.target.closest('.mini-cart .quantity__button');
    if (!btn) return;

    var wrap = btn.closest('quantity-input');
    var input = wrap && wrap.querySelector('.quantity__input');
    var cartItems = cartItemsFor(btn);
    if (!input || !cartItems) return;

    /* Take over from the theme so it cannot fire its own request per tap. */
    event.preventDefault();
    event.stopImmediatePropagation();

    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = 0;
    var next = btn.getAttribute('name') === 'plus' ? current + 1 : current - 1;
    if (next < 0) next = 0;

    input.value = next;
    say('TAP ' + btn.getAttribute('name') + ' line ' + input.dataset.index + ' -> ' + next);
    schedule(input, cartItems);
  }

  document.addEventListener('click', onQtyPress, true);

  /* Drop stale responses so a late reply can never repaint the drawer. */
  function patchCartItems() {
    var ctor = window.customElements && window.customElements.get('cart-items');
    if (!ctor || ctor.prototype.__anhSeqPatched) return;

    var proto = ctor.prototype;
    var origGetHTML = proto.getSectionInnerHTML;
    var origUpdate = proto.updateQuantity;

    proto.updateQuantity = function (line, quantity, name) {
      this.__anhSeq = newest;
      return origUpdate.call(this, line, quantity, name);
    };

    proto.getSectionInnerHTML = function (html, selector) {
      if (this.__anhSeq && this.__anhSeq < newest) {
        say('DROP stale render (seq ' + this.__anhSeq + ' < ' + newest + ')');
        var host = document.getElementById('mini-cart');
        if (host) return host.innerHTML;
      }
      return origGetHTML.call(this, html, selector);
    };

    proto.__anhSeqPatched = true;
    say('cart-items patched');
  }

  function buildDebugUI() {
    if (!DEBUG || pill) return;
    pill = document.createElement('button');
    pill.type = 'button';
    pill.textContent = 'LOG 0';
    pill.style.cssText = 'position:fixed;right:6px;top:50%;transform:translateY(-50%);z-index:2147483647;padding:6px 8px;border:0;border-radius:6px;background:#111;color:#7CFC00;font:11px ui-monospace,monospace;opacity:.85';
    panel = document.createElement('div');
    panel.style.cssText = 'position:fixed;inset:0;z-index:2147483646;display:none;flex-direction:column;background:rgba(0,0,0,.94);padding:8px;box-sizing:border-box';
    var copy = document.createElement('button');
    copy.type = 'button'; copy.textContent = 'COPY ALL';
    copy.style.cssText = 'padding:11px;border:0;border-radius:6px;background:#0a7;color:#fff;font:12px ui-monospace,monospace;margin-bottom:6px';
    copy.onclick = function () {
      var text = log.join('\n');
      if (navigator.clipboard) navigator.clipboard.writeText(text);
      copy.textContent = 'COPIED ' + log.length;
    };
    bodyEl = document.createElement('pre');
    bodyEl.style.cssText = 'flex:1;margin:0;overflow:auto;user-select:text;color:#7CFC00;white-space:pre-wrap;font:10px/1.35 ui-monospace,monospace';
    panel.appendChild(copy); panel.appendChild(bodyEl);
    pill.onclick = function () { panel.style.display = 'flex'; bodyEl.textContent = log.slice(-60).join('\n'); };
    bodyEl.ondblclick = function () { panel.style.display = 'none'; };
    document.body.appendChild(pill); document.body.appendChild(panel);
  }

  function init() {
    buildDebugUI();
    patchCartItems();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('cartdrawer:opened', patchCartItems);
  window.addEventListener('load', patchCartItems);
})();
